// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1En1N","content":"styles_content__1bk-b","row":"styles_row__4BN_j","footer":"styles_footer__H_cYT","phraseLength":"styles_phraseLength__2hH2F"};